/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  TenantNotificationConfigurationResponse,
  UpdateTenantNotificationConfigurationRequest,
  V1TenantNotificationConfigurationListError,
  V1TenantNotificationConfigurationUpdateError,
} from './data-contracts';
import { ContentType, HttpClient, RequestParams } from './http-client';

export class TenantNotificationConfiguration<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * No description
   *
   * @tags TenantNotificationConfiguration
   * @name V1TenantNotificationConfigurationList
   * @summary Gets notification configuration for the current tenant
   * @request GET:/api/v1/tenant/notification-configuration
   * @secure
   * @response `200` `TenantNotificationConfigurationResponse` OK
   * @response `401` `ProblemDetails` Unauthorized
   * @response `500` `ProblemDetailsWithErrorCode` Internal Server Error
   */
  v1TenantNotificationConfigurationList = (params: RequestParams = {}) =>
    this.http.request<
      TenantNotificationConfigurationResponse,
      V1TenantNotificationConfigurationListError
    >({
      path: `/api/v1/tenant/notification-configuration`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags TenantNotificationConfiguration
   * @name V1TenantNotificationConfigurationUpdate
   * @summary Updates notification configuration for the current tenant
   * @request PUT:/api/v1/tenant/notification-configuration
   * @secure
   * @response `204` `void` No Content
   * @response `400` `ProblemDetails` Bad Request
   * @response `401` `ProblemDetails` Unauthorized
   * @response `500` `ProblemDetailsWithErrorCode` Internal Server Error
   */
  v1TenantNotificationConfigurationUpdate = (
    data: UpdateTenantNotificationConfigurationRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<void, V1TenantNotificationConfigurationUpdateError>({
      path: `/api/v1/tenant/notification-configuration`,
      method: 'PUT',
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
}
